<template>
  <div class="datePickerOneComp">
    <date-picker
      v-model="time"
      :range="false"
      :type="'date'"
      :width="'100%'"
      :clearable="true"
      :shortcuts="shortcuts"
      :lang="lang"
      @clear="time = ''"
      :not-before="new Date()"
      :disabled="disabled"
    ></date-picker>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  name: 'datePickerOneComp',
  props: {
    disabled: { type: Boolean, default: () => true }
  },
  data: function () {
    return {
      time: '',
      shortcuts: [
        {
          text: 'Сегодня',
          onClick: () => {
            this.time = new Date()
          }
        }
      ],
      lang: {
        days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: ['Янв', 'Фев', 'Мрт', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Выбрать дату',
          dateRange: 'Выбрать промежуток'
        }
      }
    }
  },
  beforeCreate () {
  },
  created: function () {
  },
  components: {
    DatePicker
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.mx-datepicker-popup {
  z-index: 5000;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}
</style>
